import { Field as $ } from './Field.js';
import { FieldHelperText } from './FieldHelperText.js';
import { FieldLabel } from './FieldLabel.js';
export * from './Field.js';
export * from './FieldLabel.js';
export * from './FieldHelperText.js';

export const Field = Object.assign($, {
  Label: FieldLabel,
  HelperText: FieldHelperText,
});
